module.exports = __webpack_public_path__ + "images/2go/bitmap.png";